module.exports = __webpack_public_path__ + "static/media/text-uuids-icon.4e11b9c6.svg";